/* eslint-disable no-use-before-define, no-unused-vars */

import React from "react";
import {
  ActivityIndicator,
  Button as RNButton,
  Platform,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MenuButton from "../components/MenuButton";
import Icon from "react-native-vector-icons/FontAwesome";
import { attachKit, resetAttachment } from "../redux/actions/kit";
import { errorColors, RepositColours, RepositStyles } from "../utils/styles";
import goTo from "../utils/goTo";
import Phone from "../utils/Phone";

const questionCircle = (
  <Icon name="warning" size={20} color={errorColors.orange} />
);

const mapStateToProps = (state) => ({
  kit: state.kit,
  customer: state.customer,
  box: state.box,
});

const mapDispatchToProps = (dispatch) => {
  return {
    connectionActions: bindActionCreators(
      { attachKit, resetAttachment },
      dispatch
    ),
  };
};

class KitVerify extends React.Component {
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };

  componentDidMount() {
    this.props.connectionActions.resetAttachment();
  }

  componentWillReceiveProps(nextProps) {
    const nextCon = nextProps.kit.registrationStatus;
    const thisCon = this.props.kit.registrationStatus;
    if (nextCon === "SUCCESS" && thisCon !== "SUCCESS") {
      goTo(this.props.navigation, "ConnectionType");
    }
  }

  register = () => {
    const site = this.props.customer.selectedSite;
    const kit = this.props.kit.kitComponents.id;
    const serialNum = this.props.box.serialNumber;
    this.props.connectionActions.attachKit(kit, site, serialNum);
  };

  render() {
    let navigate = null;
    if (Platform.OS !== "web") {
      navigate = this.props.navigation.navigate;
    }
    const kitComponents = this.props.kit.kitComponents;
    return (
      <View style={styles.wrapper}>
        <View
          style={{
            flex: 1,
            alignItems: "stretch",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ flex: 4, justifyContent: "space-around" }}>
              <View style={{ flex: 1, justifyContent: "center" }}>
                <Text style={RepositStyles.headerText}>
                  Confirm Kit {this.props.kit.kitNumber}
                </Text>
              </View>
              <View style={{ flex: 4, justifyContent: "center" }}>
                <View style={{ flexDirection: "row", marginVertical: 5 }}>
                  <View style={{ flex: 1 }} />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      color: RepositColours.lightGrey,
                    }}
                  >
                    Battery
                  </Text>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 3,
                      marginHorizontal: 0,
                      fontWeight: "bold",
                    }}
                  >
                    {kitComponents.battery.join("\r\n")}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginVertical: 5 }}>
                  <View style={{ flex: 1 }} />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      color: RepositColours.lightGrey,
                    }}
                  >
                    Inverter
                  </Text>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 3,
                      marginHorizontal: 0,
                      fontWeight: "bold",
                    }}
                  >
                    {kitComponents.inverter.join("\r\n")}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginVertical: 5 }}>
                  <View style={{ flex: 1 }} />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      color: RepositColours.lightGrey,
                    }}
                  >
                    AC Solar Phases
                  </Text>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 3,
                      marginHorizontal: 0,
                      fontWeight: "bold",
                    }}
                  >
                    {kitComponents.solar_phases}
                  </Text>
                </View>
                <View style={{ flexDirection: "row", marginVertical: 5 }}>
                  <View style={{ flex: 1 }} />
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 2,
                      marginHorizontal: 0,
                      color: RepositColours.lightGrey,
                    }}
                  >
                    Network Phases
                  </Text>
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      flex: 3,
                      marginHorizontal: 0,
                      fontWeight: "bold",
                    }}
                  >
                    {kitComponents.network_phases}
                  </Text>
                </View>
              </View>
            </View>
            <View style={{ flex: 1 }}>
              {this.props.kit.registrationStatus === "ERROR" ? (
                <Text style={RepositStyles.paragraphText}>
                  {questionCircle} Unable to register kit. Please try against or
                  <Phone> call Reposit on</Phone>
                </Text>
              ) : null}
            </View>
            <View
              style={{
                flex: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {this.props.kit.registrationStatus === "ATTACHING" ? (
                <ActivityIndicator />
              ) : (
                <RNButton
                  title=" Next "
                  onPress={() => this.register()}
                  color={RepositColours.blue}
                />
              )}
              <Text style={RepositStyles.nextSub}>Network Connection</Text>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
});

export default connect(mapStateToProps, mapDispatchToProps)(KitVerify);



// WEBPACK FOOTER //
// ./src/containers/KitVerify.js